/** Traveling Salesman (192) — cheaper.png on hand cards when next-order discount applies */
export const TRAVELING_SALESMAN_CHEAPER_HAND_DURATION_MS = 2000;
export const CHEAPER_HAND_IMAGE_PATH = '/images/cheaper.png';

export const CHEAPER_HAND_IMAGE_STYLE = {
  width: 'min(44vw, 220px)',
  height: 'auto',
  objectFit: 'contain',
  filter: 'drop-shadow(0 0 14px rgba(120, 220, 140, 0.55))',
};

export const CHEAPER_HAND_CENTERED_IMAGE_STYLE = {
  ...CHEAPER_HAND_IMAGE_STYLE,
  display: 'block',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
};

/** Matches OrderDesign minimal hand root translateY(40px) — see duplicateStrategemAnimation.js */
export const CHEAPER_HAND_OVERLAY_MATCH_ORDER_DESIGN_TRANSFORM = 'translateY(40px)';
